import React, { ComponentType, PureComponent } from 'react';
import { AppContext } from 'services/AppContext';

const withContext = <P extends object>(Component: ComponentType<P>) => {
  class WithContext extends PureComponent<P> {
    render() {
      return <AppContext.Consumer>{value => <Component {...this.props} {...value} />}</AppContext.Consumer>;
    }
  }

  return WithContext;
};

export default withContext;
